<script>
    import { _ } from "../services/i18n";
    import Icon from "../ui/Icon.svelte";
    import { link as useLink } from "svelte-spa-router";

    import HeaderHome from "../components/HeaderHome.svelte";

    import svgCompose from "../../public/icons/home/creatucomposicion-sim3d.svg";
    import svgConfig from "../../public/icons/home/configuracion-sim3d.svg";
    import svgOrders from "../../public/icons/home/pedidos-sim3d.svg";
    import svgBudgets from "../../public/icons/home/presupuestos-sim3d.svg";
    import svgVrViewer from "../../public/icons/home/vr-viewer.svg";
    import svgImages from "../../public/icons/home/images.svg";
    import svgTechnicalOrder from "../../public/icons/home/pedidotecnico-sim3d.svg"

    import {
        userStore,
        clientDataStore,
    } from "../services/session";

    import config from "../config";
    import { onMount } from "svelte";
    import { get } from "svelte/store";

    let vrSupported = false;

    let currentClient = null;

    clientDataStore.subscribe(async (clientData) => {
        if (clientData) {
            currentClient = clientData.id;
        }
    });

    onMount(async () => {
        vrSupported =
            navigator.xr &&
            (await navigator.xr.isSessionSupported("immersive-vr"));
        vrSupported = vrSupported && currentClient !== null;
    });
</script>

<HeaderHome />

<h1 class="welcome">
    {$_("home_welcome")}
    <br />
    <strong>{$_("home_whatToDo")}</strong>
</h1>

<ul class="actions">
    <li class="composer">
        <a href="/sim3d.html">
            <Icon svg={svgCompose} />
            <span>{$_("home_createComposition")}</span>
        </a>
    </li>

    {#if $userStore.getAcl("dbOrders") && $clientDataStore.getFeature("dbOrders")}
        <li class="composer">
            <a href="/orderEdit" use:useLink>
                <Icon svg={svgTechnicalOrder} />
                <span>{$_("home_createComposition2D")}</span>
            </a>
        </li>
    {/if}

    {#if $userStore.getAcl("orderList")}
        <li class="orders">
            <a href="/orders" use:useLink>
                <Icon svg={svgOrders} />
                <span>{$_("home_seeOrders")}</span>
            </a>
        </li>
    {/if}
    {#if $userStore.getAcl("budgetList")}
        <li class="budgets">
            <a href="/budgets" use:useLink>
                <Icon svg={svgBudgets} />
                <span>{$_("home_seeBudgets")}</span>
            </a>
        </li>
    {/if}
    {#if $userStore.getAcl("manageUsers") || $userStore.getAcl("manageRate")}
        <li class="config">
            <a
                href={$userStore.getAcl("manageUsers") ? "/vendors" : "/rates"}
                use:useLink
            >
                <Icon svg={svgConfig} />
                <span>{$_("home_settings")}</span>
            </a>
        </li>
    {/if}
    {#if $userStore.getAcl("uploadImages")}
        <li class="images">
            <a href="/images" use:useLink>
                <Icon svg={svgImages} />
                <span>{$_("home_openImages")}</span>
            </a>
        </li>
    {/if}
    {#if config.vr?.enabled && vrSupported}
        <li class="vr-view">
            <a href={`/vr-orders.html?client=${currentClient}`}>
                <Icon svg={svgVrViewer} />
                <span>{$_("home_vrViewer")}</span>
            </a>
        </li>
    {/if}
    
</ul>

<svelte:head>
    <link rel="stylesheet" href="styles/pages/home.css" />
    <link rel="stylesheet" href="https://use.typekit.net/fza1vot.css" />
</svelte:head>
